import { useDirectorActions, useDirectorContext } from "@contexts/director";

// Empresa (quando o usuário vê mais de uma) e obra (filtro do contexto), no cabeçalho das telas.
const DirectorScopeControls = ({ showProjectFilter = true }) => {
  const {
    selectedCompanyId,
    accessByCompany = {},
    metadata,
    filters,
  } = useDirectorContext();
  const actions = useDirectorActions();
  const projects = metadata?.projects || [];
  return <>
    {Object.keys(accessByCompany).length > 1 && <label className="director-filter-field">
      <span>Empresa</span>
      <select value={selectedCompanyId || ""} onChange={(event) => actions?.selectCompany(event.target.value)}>
        {Object.entries(accessByCompany).map(([id, item]) => <option key={id} value={id}>
          {item.companyName}
        </option>)}
      </select>
    </label>}
    {showProjectFilter && projects.length > 1 && <label className="director-filter-field">
      <span>Obra</span>
      <select
        value={filters?.projectKey || ""}
        onChange={(event) => actions?.setFilters({
          legalEntityId: null,
          projectKey: event.target.value || null,
          costCenterId: null,
        })}
      >
        <option value="">Portfólio consolidado</option>
        {projects.map((project) => <option key={project.key} value={project.key}>
          {project.name}
        </option>)}
      </select>
    </label>}
  </>;
};

export default DirectorScopeControls;
